/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import {Breakpoints} from "../../../../constants/Breakpoints";

const ForgotPasswordContainer = styled.div`
  position: relative;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  flex-basis: 0;
  flex-grow: 1;
  padding: 0 0.5rem;

  @media screen and (min-width: ${Breakpoints.sm}) {
    width: 80%;
    padding: 0;
  }
`;

export { ForgotPasswordContainer };

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  justify-content: center;

  @media screen and (min-width: ${Breakpoints.sm}) {
    justify-content: flex-end;    
  }

  @media screen and (min-width: ${Breakpoints.sm}) {
    position: absolute;
    right: calc(4rem + 4px);
    bottom: calc(2rem + 4px);
  }
`;

export { ButtonContainer };
